import {engineContext} from './context.js';

(function(global){
'use strict';
const VERSION='0.1.0-alpha';

function normEvent(x){
  x=x||{};
  return Object.freeze({
    symbol:x.symbol||null,
    timestamp:Number.isFinite(x.timestamp)?x.timestamp:null,
    actor:x.actor||'SYSTEM',
    type:x.type||'UNKNOWN',
    from:x.from===undefined?null:x.from,
    to:x.to===undefined?null:x.to,
    evidenceFingerprint:x.evidenceFingerprint||null,
    note:x.note||null
  });
}
function append(history,event){
  const rows=Array.isArray(history)?history.map(normEvent):[];
  const e=normEvent(event);
  return Object.freeze([...rows,e].sort((a,b)=>(a.timestamp||0)-(b.timestamp||0)));
}
function changesForSymbol(history,symbol){
  const rows=(Array.isArray(history)?history:[]).map(normEvent).filter(x=>x.symbol===symbol);
  return Object.freeze(rows.sort((a,b)=>(a.timestamp||0)-(b.timestamp||0)));
}
function latest(history,symbol,type){
  const rows=changesForSymbol(history,symbol).filter(x=>!type||x.type===type);
  return rows.length?rows[rows.length-1]:null;
}
function explainLatest(history,symbol){
  const e=latest(history,symbol);
  if(!e) return Object.freeze({symbol,headline:'No decision-state history recorded.',tradeSignal:false});
  const from=e.from===null?'unknown':String(e.from);
  const to=e.to===null?'unknown':String(e.to);
  return Object.freeze({
    symbol,
    headline:`${e.type}: ${from} → ${to}`,
    evidenceFingerprint:e.evidenceFingerprint,
    note:e.note,
    tradeSignal:false
  });
}
function selfTest(){
  const t=[],ok=(n,p)=>t.push({name:n,pass:!!p});
  const h=[
    {symbol:'AAA',timestamp:100,type:'READINESS',from:'REVIEW',to:'BLOCKED',evidenceFingerprint:'x'},
    {symbol:'BBB',timestamp:90,type:'PRIORITY',from:'LOW',to:'HIGH'},
    {symbol:'AAA',timestamp:200,type:'READINESS',from:'BLOCKED',to:'REVIEW',evidenceFingerprint:'y'}
  ];
  ok('append adds event',append(h,{symbol:'AAA',timestamp:300,type:'PRIORITY'}).length===4);
  ok('append keeps chronological order',append(h,{symbol:'AAA',timestamp:50,type:'PRIORITY'})[0].timestamp===50);
  ok('symbol history filters correctly',changesForSymbol(h,'AAA').length===2);
  ok('latest event is latest by timestamp',latest(h,'AAA').timestamp===200);
  ok('latest by type works',latest(h,'AAA','READINESS').timestamp===200);
  ok('missing history returns null latest',latest(h,'CCC')===null);
  ok('explanation names transition',explainLatest(h,'AAA').headline.includes('BLOCKED → REVIEW'));
  ok('explanation carries evidence fingerprint',explainLatest(h,'AAA').evidenceFingerprint==='y');
  ok('missing history has safe explanation',explainLatest(h,'CCC').headline.length>0);
  ok('audit trail remains non-trading',explainLatest(h,'AAA').tradeSignal===false);
  return Object.freeze({passed:t.filter(x=>x.pass).length,total:t.length,tests:Object.freeze(t)});
}
const API={VERSION,normEvent,append,changesForSymbol,latest,explainLatest,selfTest};
try{API.selfTestResult=selfTest()}catch(e){API.bootstrapError=String(e&&e.stack||e)}
global.ZooInvestDecisionAuditTrailEngine=Object.freeze(API);
})(engineContext);
